<template>
  <RevContainer class="py-32 text-center">
    <div class="mb-32">
      <p class="punchline mb-16">
        {{ error.statusCode }}
      </p>
      <h1 class="punchline">
        {{ i18n(translations.title) }}
      </h1>
    </div>

    <p class="body-1">
      {{ i18n(translations.beCool) }}
    </p>
    <RevIllustration
      alt=""
      class="mx-auto my-32 block h-[220px] w-full object-cover md:h-320 md:w-448"
      :height="320"
      sizes="(min-width: 768px) 100vw, 220px"
      src="/img/404.jpg"
      :width="448"
    />
    <RevButton
      v-if="buttonRoute"
      data-test="cta-button"
      :to="buttonRoute"
      variant="primary"
    >
      {{ i18n(translations.cta) }}
    </RevButton>
  </RevContainer>
</template>

<script lang="ts" setup>
import type { NuxtError } from '#app'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevContainer } from '@ds/components/Container'
import { RevIllustration } from '@ds/components/Illustration'
import type { Location } from '@ds/types/Location'

import translations from './Error4xx.translations'

const i18n = useI18n()

defineProps<{
  error: NuxtError
  buttonRoute?: Location
}>()
</script>
